<template>
  <div class="modalApp" v-if="editDialogVisible">
    <el-dialog :title="$lang(diglogTitle)" :visible.sync="editDialogVisible" width="800px" @close="handleClose" :modal-append-to-body="false"
               :close-on-click-modal="false">
      <el-form class="el-form-edit" :model="tableForm" ref="tableForm" :rules="rules" :inline="true"  label-position="left" label-suffix=" :">
        <el-row>
          <el-col :span="20" class="waybillNo">
            <el-form-item prop="waybillNo" :label="$lang('运单号')">
              <el-input @input="waybillNoChange($event,1)"  v-model="tableForm.waybillNo" :placeholder="$lang('请输入')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="red" style="margin-left: 80px" v-show="tableForm.msg">{{ $lang(tableForm.msg)}}</div>
        <el-row class="address" v-show="tableForm.senderName">
          <div class="address_list">
            <div class="list_left">{{$lang('寄')}}</div>
            <div class="list_right">
              <div class="top1">
                <span class="name">{{ tableForm.senderName }}</span>
                <span class="phone">{{ tableForm.senderMobilePhone }}</span>
              </div>
              <div class="ads">{{ tableForm.senderDetailedAddress }}</div>
            </div>
          </div>
          <div class="address_list">
            <div class="list_left left2">{{$lang('收')}}</div>
            <div class="list_right">
              <div class="top1">
                <span class="name">{{ tableForm.receiverName }}</span>
                <span class="phone">{{ tableForm.receiverMobilePhone }}</span>
              </div>
              <div class="ads">{{ tableForm.receiverDetailedAddress }}</div>
            </div>
          </div>
        </el-row>
        <el-row class="grayBox">
          <el-col :span="6">
            <el-form-item style="width: 100% !important;" prop="customerPhone" :label="$lang('回电号码')">
              <el-input style="width: 100% !important;" v-model="tableForm.customerPhone" :placeholder="$lang('请输入')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item style="width: 100% !important;" prop="firstTypeId" :label="$lang('一级类型')">
              <el-select clearable v-model="tableForm.firstTypeId" filterable @change="firstTypeCodeChange($event,1)">
                <el-option
                    style="width: 100% !important;"
                    v-for="item in firstTypeCodeList"
                    :key="item.id"
                    :label="$lang(item.name)"
                    :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item style="width: 100% !important;" prop="secondTypeId" :label="$lang('二级类型')">
              <el-select clearable v-model="tableForm.secondTypeId" filterable>
                <el-option
                    style="width: 100% !important;"
                    v-for="item in secondTypeCodeList"
                    :key="item.id"
                    :label="$lang(item.name)"
                    :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="grayBox">
          <el-col :span="24">
            <el-form-item style="width: 100% !important;" prop="problemDescription" :label="$lang('问题描述')">
              <el-input type="textarea" v-model="tableForm.problemDescription" :autosize="{ minRows: 4, maxRows: 6}"  maxLength="500" :placeholder="$lang('请输入问题描述')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="close_btn" type="primary" :loading="loading" @click="handleSubmit()">{{ $lang('提交订单') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { RESPONSE_SUCCESS } from '@constants'

import { RULES, phoneAndMobile } from '@utils/rules'
import { workOrderCheckByWaybill, workOrderFirstType, workOrderSecondType, workOrderAdd } from '../pool'
export default {
  components: {},
  props: {
    editDialogVisible: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      diglogTitle: '问题报告',
      tableForm: {
        waybillNo: '',
        customerPhone: '',
        firstTypeId: '',
        secondTypeId: '',
        problemDescription: '',
        senderName: '',
        senderMobilePhone: '',
        senderDetailedAddress: '',
        receiverName: '',
        receiverMobilePhone: '',
        receiverDetailedAddress: '',
        msg: ''
      },
      loading: false,
      rules: {
        waybillNo: [RULES.requiredTrim],
        customerPhone: [RULES.requiredTrim, { validator: phoneAndMobile }],
        firstTypeId: [RULES.requiredSelect],
        secondTypeId: [RULES.requiredSelect],
        problemDescription: [RULES.requiredTrim],
      },
      firstTypeCodeList: [],
      secondTypeCodeList: [],
    }
  },
  created() {
    this.getFirstTypeCodeListFun()
  },
  methods: {
    waybillNoChange(e) {
      this.tableForm.msg = ''
      this.workOrderCheckByWaybillFun(e)
    },
    async workOrderCheckByWaybillFun(id) {
      const self = this
      await workOrderCheckByWaybill({ waybillNo: id }).then(res => {
        const { code, data, msg } = res
        if (code === RESPONSE_SUCCESS) {
          const senderDetailedAddress = data.senderDetailedAddress || ''
          const receiverDetailedAddress = data.receiverDetailedAddress || ''
          self.tableForm.msg = ''
          self.tableForm.senderName = data.senderName || ''
          self.tableForm.senderMobilePhone = data.senderMobilePhone || ''
          self.tableForm.senderDetailedAddress = data.senderProvinceName + data.senderCityName + data.senderAreaName + '-' + senderDetailedAddress
          self.tableForm.receiverName = data.receiverName || ''
          self.tableForm.receiverMobilePhone = data.receiverMobilePhone || ''
          self.tableForm.receiverDetailedAddress = data.receiverProvinceName + data.receiverCityName + data.receiverAreaName + '-' + receiverDetailedAddress
        } else {
          self.tableForm.msg = msg
          self.tableForm.senderName = ''
          self.tableForm.senderMobilePhone = ''
          self.tableForm.senderDetailedAddress = ''
          self.tableForm.receiverName = ''
          self.tableForm.receiverMobilePhone = ''
          self.tableForm.receiverDetailedAddress = ''
        }
      })
    },
    setCodeFun (data2) {
      if (!data2) return ''
      const encodedData1 = encodeURIComponent(data2)
      const decodedData1 = decodeURIComponent(encodedData1)
      return decodedData1
    },
    async getFirstTypeCodeListFun() {
      await workOrderFirstType({}).then(res => {
        const { code, data } = res
        if (code === RESPONSE_SUCCESS) {
          this.firstTypeCodeList = data || []
        }
      })
    },
    firstTypeCodeChange(e, id) {
      this.tableForm.secondTypeId = ''
      this.secondTypeCodeList = []
      this.getSecondTypeCodeListFun(e)
    },
    async getSecondTypeCodeListFun(id) {
      await workOrderSecondType({ firstId: id }).then(res => {
        const { code, data } = res
        if (code === RESPONSE_SUCCESS) {
          this.secondTypeCodeList = data || []
        }
      })
    },
    handleClose() {
      this.tableForm.msg = ''
      this.tableForm.senderName = ''
      this.tableForm.senderMobilePhone = ''
      this.tableForm.senderDetailedAddress = ''
      this.tableForm.receiverName = ''
      this.tableForm.receiverMobilePhone = ''
      this.tableForm.receiverDetailedAddress = ''
      this.$refs.tableForm.resetFields()
      this.$emit('closeMoadl')
    },
    handleSubmit() {
      if (!this.tableForm.senderName || !this.tableForm.receiverName) {
        if (this.tableForm.msg) {
          this.$message.error(this.$lang(this.tableForm.msg + ',请重新查询'))
        } else {
          this.$message.error(this.$lang('查询的运单号没有对应的寄件人&收件人信息,请重新查询'))
        }
        return
      }
      this.$refs.tableForm.validate((valid, values) => {
        if (valid) {
          console.log(this.tableForm)
          this.loading = true
          // const param = JSON.parse(JSON.stringify(this.searchParam))
          workOrderAdd(this.tableForm).then(res => {
            const { code, msg } = res
            this.loading = false
            if (code === RESPONSE_SUCCESS) {
              this.$message.success(this.$lang('保存成功！'))
              this.handleClose()
            } else {
              this.$message.error(this.$lang(msg))
            }
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.modalApp ::v-deep .el-input {
  width: 100% !important;
}

.waybillNo ::v-deep .el-form-item__label {
  display: inline-block !important;
}

.waybillNo ::v-deep .el-form-item--small {
  width: 260px;
  display: flex !important;
  align-items: center !important;
}

.modalApp ::v-deep .el-dialog__body {
  padding: 20px 40px;
}
.grayBox{
  width: 100%;
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 20px 10px 0 10px;
  margin-top: 14px;
}

.address{
  padding: 0px 0 20px 0;
  border-top: 1px dashed #ccc;
  .address_list{
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    .list_left{
      font-size: 18px;
      width: 55px;
      height: 55px;
      line-height: 55px;
      text-align: center;
      color: #FFFFFF;
      border-radius: 50%;
      background-color: #af1818;
    }
    .left2{
      color: #af1818;
      background-color: #FFFFFF;
      border: 1px solid #af1818;
    }
    .list_right{
      margin-left: 10px;
      .top1{
        .name{
          font-weight: 800;
          color: #222;
        }
        .phone{
          margin-left: 20px;
          font-size: 13px;
        }
      }
      .ads{
        margin-top: 8px;

      }
    }
  }
}

.dialog-footer{
  display: flex;
  justify-content: center;
}
.close_btn{
  width: 100px;
  background-color: red;
  color: #fff;
}
</style>
